import { Typography, InputAdornment, Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import SVTextInput from './SVTextInput';

interface SVPersonalBankingLinkFieldProps {
  name: string;
  label: string;
  advisorUrl: string;
  alias: string;
}

export default function SVPersonalBankingLinkField({
  name,
  label,
  advisorUrl,
  alias,
}: SVPersonalBankingLinkFieldProps) {
  const { setValue } = useFormContext();

  // Extract base URL from advisorUrl
  const baseAdvisorUrl = advisorUrl.split('/p/')[0] + '/p/';

  useEffect(() => {
    setValue(name, alias);
  }, [alias, name, setValue]);

  const aliasValidationRules = {
    required: true,
    minLength: 3,
    maxLength: 15,
    pattern: {
      regex: /^[a-z0-9_-]*$/,
      readablePatternName:
        'lowercase letters, numbers, hyphens, and underscores only',
    },
  };

  // Prevent invalid characters from being typed
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const key = e.key;
    const isValidChar =
      /^[a-z0-9_-]$/.test(key) ||
      key === 'Backspace' ||
      key === 'Delete' ||
      key === 'Tab' ||
      key === 'ArrowLeft' ||
      key === 'ArrowRight' ||
      key === 'Home' ||
      key === 'End';

    if (!isValidChar) {
      e.preventDefault();
    }
  };

  return (
    <Box>
      <SVTextInput
        name={name}
        label={label}
        rules={aliasValidationRules}
        inputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Typography sx={{ fontSize: '18px', marginTop: '2px' }}>
                {baseAdvisorUrl}
              </Typography>
            </InputAdornment>
          ),
          inputProps: {
            maxLength: 15,
            style: {
              paddingLeft: 0,
              marginLeft: '-7px',
            },
            onKeyDown: handleKeyDown,
          },
        }}
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          margin: '2px',
          marginTop: -4,
          marginLeft: '15px',
          marginRight: '5px',
          position: 'absolute',
          width: 'calc(100% - 20px)',
          pointerEvents: 'none',
        }}>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            fontSize: '0.875rem',
          }}>
          3-15 chars, a-z, 0-9, -, _
        </Typography>
      </Box>
    </Box>
  );
}
